import { withResourceState } from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { EInvoiceSubmissionsService } from '../services/e-invoice-submissions.service';

export const EInvoiceSubmissionsStore = signalStore(
  { protectedState: false },
  withResourceState(EInvoiceSubmissionsService, {
    query: {
      initial: {
        sort: ['-createdAt'],
      },
    },
  }),
);
